import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ManageEquipmentService } from '../../manage-equipment.service';

import { AppService } from '../../../../../app/app.service';
import { SystemDetails, Inspection, ComponentDetails, InspectionWornInfo, InspectionHistroyWornInfo, SystemInspectionInfo } from '../../models/manage-equipment.model';
import { MatDialog } from '@angular/material/dialog';import { InspectionNoteComponent } from '../inspection-note/inspection-note.component';
import { UserService } from '../../../../../app/shared/services/user.service';
import { GETPreferencesService } from '../../../../modules/GET_NEW_UI/preferences/preferences.service';
import { CustomeEvaluationRangeVM } from '../../../../../app/modules/CustomEval/custom-eval.model';
import { CustomEvalService } from '../../../../..//app/modules/CustomEval/custom-eval.service';
import moment from 'moment';
import { CryptoService } from '../../../../services/crypto.service';



@Component({
  selector: 'app-inspection-history',
  templateUrl: './inspection-history.component.html',
  styleUrls: ['./inspection-history.component.scss']
})
export class InspectionHistoryComponent implements OnInit {
  @Input() equipmentId: number;
  @Input() eqName: string;
  @Input() ThermEnabled: boolean
  @Input() FamilyId: number
  LastInspectionWorn:boolean=false;
  WornPercentageToday:boolean=true;
@Output() showCurrentOrForecast = new EventEmitter<boolean>();
  @Input() MaintenaceEnables: boolean


ToadysDate:Date= new Date();
  
  equipmentSystems: SystemDetails[];
  LeftSystem: ComponentDetails[];
  RightSystem: ComponentDetails[];
  inspections: Inspection[];
  inspectionsHistory: InspectionHistroyWornInfo[] = null;
  inspectionsGeneralHistory: InspectionHistroyWornInfo[] = null;

  inspectionsActionHistory: InspectionHistroyWornInfo[] = null;
  inspectionsEOLHistory: InspectionHistroyWornInfo[] = null;


  inspectionsHistoryThermo: InspectionHistroyWornInfo[] = null;
  inspectionsHistoryBoth: InspectionHistroyWornInfo[] = null;


  systemInfoList: InspectionWornInfo[];
  Count: number = 1;
  LoadCount: number = 6;
  inspectionType = 0;
  ThermoSystem_L: SystemInspectionInfo[] = [];
  ThermoSystem_R: SystemInspectionInfo[] = [];
  ThermoSystem_Addi_L: SystemInspectionInfo[] = [];
  ThermoSystem_Addi_R: SystemInspectionInfo[] = [];
  ThermoSystem_Addi_No: SystemInspectionInfo[] = [];
  
  Chaindata: SystemInspectionInfo[] = [];
  ucInspection: boolean = true;
  maintenaceInspection: boolean = false;

  eolInspection: boolean = false;
  thermographyInspection: boolean = false;


  curremtStatus: boolean;
  distance: boolean = true;
  distanceDifference: boolean = true;
  jobsite: boolean = true;
  inspector: boolean = true;
  worn: boolean = false;
  showWorn: boolean = false;
  userUOD: string = 'km'; 
  constructor(
    private _equipmentService: ManageEquipmentService, 
    private _app: AppService,
    private _dialog: MatDialog,
    private _userService: UserService,
    private _pref: GETPreferencesService, private _evalService: CustomEvalService,
    private crypto: CryptoService
    ) { }

    
  ngOnInit() {
    this._app.getApplicationConfigValue("CurrentStatusDefaultValue").subscribe(result => {
     
      if (result == "1") {
        this.curremtStatus = true;
      } else {
        this.curremtStatus = false;

      }

  });
  this.CheckFindIspectionMenuAccess();
    this.loadEquipmentSystems();
    //this.loadEquipmentInspections();
    this.LoadGeneralInspectionsList();
    this.LoadThermInspectionList();
    //this.LoadBothInspectionList();
    this.LoadActionInspectionsList();
    this.LoadEOLInspectionsList();
    this.getUserPref();

  }
  LoadMore() {
    this.Count = this.Count + 1;
    this.LoadCount = this.LoadCount * this.Count;
    //this.loadEquipmentInspections();
    //this.loadInspectionHistoryWorn();
    this.LoadGeneralInspectionsList();
    this.LoadThermInspectionList();
    //this.LoadBothInspectionList();
    this.LoadActionInspectionsList();
    this.LoadEOLInspectionsList();
    //this.calculateDistanceDiff();
  }
  ShowUCInspection(event: any) {
   //console.log("Event__", event, this.ucInspection,this.maintenaceInspection) 
    this.thermographyInspection = false;
   //console.log("Events", event.checked)
   this.inspectionsHistory = null;
    if (event.checked == true) {
    this.inspectionsHistory = this.inspectionsGeneralHistory;
      if (this.maintenaceInspection == true) {
        let inspectionsHistory_ = [...this.inspectionsGeneralHistory, ...this.inspectionsActionHistory].sort(x => x.Smu);


    inspectionsHistory_.sort(
          function (a, b) {
        var x = a.Smu
        var y = b.Smu         
         if (a.Smu === b.Smu) {
            return b.Id - a.Id;
         }
         return x > y ? -1 : x < y ? 1 : 0;
      });
    
      this.inspectionsHistory = inspectionsHistory_
     // this.inspectionsHistory = (this.inspectionsGeneralHistory.concat(this.inspectionsActionHistory)).sort(x=>x.Smu);;
        if (this.eolInspection == true) {
        console.log("New Change__")
        let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsEOLHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
      inspectionsHistory_.sort(
            function (a, b) {
          var x = a.Smu
          var y = b.Smu      
           return x > y ? -1 : x < y ? 1 : 0;
        });
          this.inspectionsHistory = inspectionsHistory_;

      }
    }
    } else {
      if (this.maintenaceInspection == true) {
      this.inspectionsHistory = this.inspectionsActionHistory;
        if (this.eolInspection == true) {
      //this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
      let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsEOLHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
      inspectionsHistory_.sort(
            function (a, b) {
          var x = a.Smu
          var y = b.Smu      
           return x > y ? -1 : x < y ? 1 : 0;
        });
          this.inspectionsHistory = inspectionsHistory_;

      }
    }
   }
    this.calculateDistanceDiff();
  }

   getChildRowPosition(componentId: number, systemId: number): string {
    const component = this.getComponent(componentId,systemId);
    //const children = this.system.Components.filter(c => c.ComponentTypeId === component.ComponentTypeId && c.IsChild);
    const children = this.equipmentSystems.find(x=>x.Id === systemId).Components.filter(c => c.ParentComponentId === component.ParentComponentId);
    if (children.length > 0) {
      if (children[children.length - 1].Id === componentId) return '--half';
      else if (children[0].Id === componentId) return '--extended';
    }
    return '';
  }
    getComponent(componentId: number, systemId: number): any {
    return this.equipmentSystems.find(x=>x.Id === systemId).Components.find(c => c.Id === componentId);
  }

  ShowActionInspection(event: any) {
    this.inspectionsHistory = null;
    this.thermographyInspection = false;
    if (event.checked == true) {
    this.inspectionsHistory = this.inspectionsActionHistory;
      if (this.ucInspection == true) {
     // this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsGeneralHistory)).sort(x=>x.Smu);
      let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsGeneralHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
      inspectionsHistory_.sort(
          function (a, b) {
          var x = a.Smu
          var y = b.Smu    
          if (a.Smu === b.Smu) {
            return b.Id - a.Id;
         }  
           return x > y ? -1 : x < y ? 1 : 0;
        });
        this.inspectionsHistory = inspectionsHistory_;

        if (this.eolInspection == true) {
      //this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);
      let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsEOLHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
      inspectionsHistory_.sort(
            function (a, b) {
          var x = a.Smu
          var y = b.Smu    
          //if (a.Smu === b.Smu) {
           // return b.Id - a.Id;
        // }  
           return x > y ? -1 : x < y ? 1 : 0;
        });
     this.inspectionsHistory = inspectionsHistory_;

        }
      }
    } else {
      if (this.ucInspection == true) {
        this.inspectionsHistory = this.inspectionsGeneralHistory;
        if (this.eolInspection == true) {
          //this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);
          let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsEOLHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
          inspectionsHistory_.sort(
            function (a, b) {
              var x = a.Smu
              var y = b.Smu
              //if (a.Smu === b.Smu) {
              // return b.Id - a.Id;
              // }  
              return x > y ? -1 : x < y ? 1 : 0;
            });
          this.inspectionsHistory = inspectionsHistory_;


        }
      }
    }
    this.calculateDistanceDiff();
  }

  ShowEOLInspection(event: any) {
    this.inspectionsHistory = null;
    this.thermographyInspection = false;
    if (event.checked == true) {

      this.inspectionsHistory = this.inspectionsEOLHistory;
      if (this.ucInspection == true) {
        // this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsGeneralHistory)).sort(x=>x.Smu);;
        let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsGeneralHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
        inspectionsHistory_.sort(
          function (a, b) {
            var x = a.Smu
            var y = b.Smu

            return x > y ? -1 : x < y ? 1 : 0;


          });
        this.inspectionsHistory = inspectionsHistory_;

        if (this.maintenaceInspection == true) {
          //this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsActionHistory)).sort(x=>x.Smu);;
          let inspectionsHistory_ = [...this.inspectionsActionHistory, ...this.inspectionsHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
          inspectionsHistory_.sort(
            function (a, b) {
              var x = a.Smu
              var y = b.Smu

              return x > y ? -1 : x < y ? 1 : 0;
            });
          this.inspectionsHistory = inspectionsHistory_;

        }
      }
    } else {
      if (this.ucInspection == true) {
        this.inspectionsHistory = this.inspectionsGeneralHistory;
        if (this.maintenaceInspection == true) {
          // this.inspectionsHistory = (this.inspectionsHistory.concat(this.inspectionsActionHistory)).sort(x=>x.Smu);;
          let inspectionsHistory_ = [...this.inspectionsHistory, ...this.inspectionsActionHistory]; //(this.inspectionsHistory.concat(this.inspectionsEOLHistory)).sort(x=>x.Smu);;
          inspectionsHistory_.sort(
            function (a, b) {
              var x = a.Smu
              var y = b.Smu

              return x > y ? -1 : x < y ? 1 : 0;
            });
          this.inspectionsHistory = inspectionsHistory_;
        }

      }
    }
    this.calculateDistanceDiff();
  }

  ShowThermogarphyInspection(event: any) {
    this.inspectionsHistory = null
    if (event.checked == true) {

      this.inspectionsHistory = this.inspectionsHistoryThermo;
      this.ucInspection = false;
      this.maintenaceInspection = false;
      this.eolInspection = false;
    } else {

      this.ucInspection = true;
      this.inspectionsHistory = this.inspectionsGeneralHistory;
    }


  }
  ChangeInspectionType(event: any) {
    if (event.value == 0) {
      //this.inspectionsHistory=null;
      //this.LoadGeneralInspectionsList();
    }

    else if (event.value == 1) {
      //this.inspectionsHistory=null;
      //this.LoadThermInspectionList();
    }

    else {
      //this.LoadBothInspectionList();
      //this.LoadGeneralInspectionsList();
      //this.LoadThermInspectionList();
    }
  }
  IsLeftExapand = false;
  IsRightExapand = false;

  ChainExpandL() {
    this.inspectionsHistoryThermo.map(x => {
      x.L_expanded = !x.L_expanded;
      this.IsLeftExapand = x.L_expanded;
    })
  }

  ChainExpandR() {
    this.inspectionsHistoryThermo.map(x => {
      x.R_expanded = !x.R_expanded;
      this.IsRightExapand = x.R_expanded;
    })
  }


  LoadBothInspectionList() {
    this._equipmentService.getEquipmentBothTypeInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      console.log("BOTH__", inspections)
      this.inspectionsHistoryBoth = inspections;
    })
  }
  LoadThermInspectionList() {
    console.log("ThermoCount", this.LoadCount)
    this._equipmentService.getEquipmentThermographyInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      //AES256
      inspections.forEach((insp: any) => {
        if (insp?.Inspector && insp.Inspector.length > 0) {
          insp.Inspector = this.crypto.decrypt(insp.Inspector);
        }
      });
      this.inspectionsHistoryThermo = inspections;
      console.log(" this.inspectionsHistoryWornNewThermo__________", this.inspectionsHistoryThermo)

      if (this.inspectionsHistoryThermo.length > 0) {
        this.ThermoSystem_L = this.inspectionsHistoryThermo[0].LeftSide;
        this.ThermoSystem_R = this.inspectionsHistoryThermo[0].RightSide;
        this.ThermoSystem_Addi_L = this.inspectionsHistoryThermo[0].LeftAdditional;
        this.ThermoSystem_Addi_R = this.inspectionsHistoryThermo[0].RightAdditional;
        this.ThermoSystem_Addi_No = this.inspectionsHistoryThermo[0].NoAdditional;
        this.Chaindata = this.inspectionsHistoryThermo[0].LeftThermoChain;
      }


      console.log("this.ThermoSystem_L", this.ThermoSystem_L)
      console.log("this.ThermoSystem_R", this.ThermoSystem_R)

    });


  }
  showNotreleasdInspections: boolean = false;
  CheckFindIspectionMenuAccess() {
    this._userService.CheckFindIspectionMenuAccess().subscribe(res => {
      if (res == true)
        this.showNotreleasdInspections = true;
      else
        this.showNotreleasdInspections = false;
    })
  }
  LoadGeneralInspectionsList() {
    //this.LeftSystem = this.equipmentSystems[0].Components;
    //this.RightSystem = this.equipmentSystems[2].Components;

    console.log("LoadCount", this.LoadCount)
    this._equipmentService.getEquipmentGeneralInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      //AES256
      inspections.forEach((insp: any) => {
        if (insp?.Inspector && insp.Inspector.length > 0) {
          insp.Inspector = this.crypto.decrypt(insp.Inspector);
        }
      });
      if (this.showNotreleasdInspections == false) {
        this.inspectionsHistory = inspections.filter(x => x.Interpreted == true);
        this.inspectionsGeneralHistory = inspections.filter(x => x.Interpreted == true);;
      } else {
        this.inspectionsHistory = inspections;
        this.inspectionsGeneralHistory = inspections;
      }
      this.calculateDistanceDiff();
      console.log("this.inspectionsHistoryWornNew_GENERAL__", this.inspectionsGeneralHistory)
    });
  }

  LoadActionInspectionsList() {
    //this.LeftSystem = this.equipmentSystems[0].Components;
    //this.RightSystem = this.equipmentSystems[2].Components;

    console.log("LoadCount", this.LoadCount)
    this._equipmentService.getEquipmentActionInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      //AES256
      inspections.forEach((insp: any) => {
        if (insp?.Inspector && insp.Inspector.length > 0) {
          insp.Inspector = this.crypto.decrypt(insp.Inspector);
        }
      });
      if (this.showNotreleasdInspections == false) {
        this.inspectionsActionHistory = inspections.filter(x => x.Interpreted == true);

      } else {
        this.inspectionsActionHistory = inspections;
      }
      console.log("this.inspectionsHistoryWornNew_ACTION________", this.inspectionsActionHistory)
    });
  }

  LoadEOLInspectionsList() {
    //this.LeftSystem = this.equipmentSystems[0].Components;
    //this.RightSystem = this.equipmentSystems[2].Components;

    console.log("LoadCount", this.LoadCount)
    this._equipmentService.getEquipmentEOLInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      //AES256
      inspections.forEach((insp: any) => {
        if (insp?.Inspector && insp.Inspector.length > 0) {
          insp.Inspector = this.crypto.decrypt(insp.Inspector);
        }
      });
      this.inspectionsEOLHistory = inspections;
      console.log(" this.inspectionsHistoryWornNew_EOL________", this.inspectionsEOLHistory)
    });
  }
ForeacastCmu:number;
ShowTodayWorn:boolean=true;
  loadEquipmentSystems() {
 const today = new Date();
    this._equipmentService.getEquipmentSystems(this.equipmentId,moment(today).format('MM/DD/YYYY')).subscribe(systems => {
      this.equipmentSystems = systems;

      console.log("_____EQSYSYSTEM", this.equipmentSystems)
      this.LoadEvalautionForEquipment(this.equipmentId);
      if (this.equipmentSystems != null) {
        //this.ShowTodayWorn= this.equipmentSystems[0].ShowTodayWorn;
        this.LeftSystem = this.equipmentSystems[0].Components;
        this.RightSystem = this.equipmentSystems[2].Components;
       
        this.ForeacastCmu= this.LeftSystem[0].ForeCastCmu;
        this.equipmentSystems[1].Components.map(x => {
          this.LeftSystem.push(x);
        })
        this.equipmentSystems[3].Components.map(x => {
          this.RightSystem.push(x);
        })
console.log("LeftSystem", this.LeftSystem)
      }
      // this.loadInspectionHistoryWorn();

    });



  }

  showPosition(position: number, compartTypeId: number): string {
    return this._app.getPositionString(position, compartTypeId);
  }
  loadEquipmentInspections() {

    this._equipmentService.getEquipmentInspectionsForHistoryLoadCount(this.equipmentId, this.LoadCount).subscribe(inspections => {
      this.inspections = inspections;
      console.log(" this.inspections___", this.inspections)
    });
  }
  arr_compLeft: any[] = []
  arr_compRight: any[] = []
  loadInspectionHistoryWorn() {
    this.arr_compLeft = [];
    this.arr_compRight = [];
    this._equipmentService.getEquipmentInspectionsHistory(this.equipmentId, this.LoadCount).subscribe(res => {
      console.log("InspectionHistory____", res)
      console.log("LeftSystem___", this.LeftSystem)
      this.systemInfoList = res;

      this.systemInfoList.map(ins => {
        ins.systemInfo.map(s => {
          if (s.Side == 1) {
            s.Components.map(comp => {

              //check fo exit
              let chek = this.arr_compLeft.find(f => f.ComponentId == comp.ComponentId)
              if (!chek) {
                let obj = {}
                obj["Name"] = comp.Name
                obj["Position"] = comp.Position
                obj["ComponentTypeId"] = comp.ComponentTypeId
                obj["ComponentId"] = comp.ComponentId
                obj["Inspections"] = []
                this.arr_compLeft.push(obj)
              }
            })
          } else {
            s.Components.map(comp => {
              //check fo exit
              let chek = this.arr_compRight.find(f => f.ComponentId == comp.ComponentId)
              if (!chek) {
                let obj = {}
                obj["Name"] = comp.Name
                obj["Position"] = comp.Position
                obj["ComponentTypeId"] = comp.ComponentTypeId
                obj["ComponentId"] = comp.ComponentId
                obj["Inspections"] = []
                this.arr_compRight.push(obj)
              }
            })
          }


        })
      })

      this.arr_compRight.map(m => {
        this.systemInfoList.map(ins => {
          ins.systemInfo.map(s => {
            if (s.Side == 1) {
              // let find = s.Components.find(f => f.ComponentId == m.ComponentId)

              // m["Inspections"].push(find)
            } else {
              let find = s.Components.find(f => f.ComponentId == m.ComponentId)
              if (find) {
                m["Inspections"].push(find)
              }

            }
          })
        })
      })

      this.arr_compLeft.map(m => {
        this.systemInfoList.map(ins => {
          ins.systemInfo.map(s => {
            if (s.Side == 1) {
              let find = s.Components.find(f => f.ComponentId == m.ComponentId)
              if (find) {
                m["Inspections"].push(find)
              }

            } else {
              // let find = s.Components.find(f => f.ComponentId == m.ComponentId)

              // m["Inspections"].push(find)
            }
          })
        })
      })
      console.log("arr_compRight", this.arr_compRight)
      console.log("arr_compLeft", this.arr_compLeft)


    })


  }

  OpenInspectionComment(data: any) {
    const inspectionNote = this._dialog.open(InspectionNoteComponent, {
      panelClass: 'removeModalOverflow',
      data: {
        familyId: this.FamilyId,
        comment: (this.FamilyId == 177 || this.FamilyId == 203) ? data.RspNote : data.generalComment,
        Interpcomment: data.Interpcomment,
        ActionComment: data.ActionComment,
        InspectionType: data.InspectionTypeId,
      }
    });

    inspectionNote.afterClosed().subscribe(() => {

    });

  }

  showorHideCurrentStatus: boolean = false;

  ShowCurrentStatus(event: any) {
    if (event.checked == true) {
      this.showorHideCurrentStatus = true;
    } else {
      this.showorHideCurrentStatus = false;
    }
    this.showCurrentOrForecast.emit(this.showorHideCurrentStatus)
  }

  ShowTodayWornPercentage(event: any) {
    if (event.checked == true) {
      this.ShowTodayWorn = true;
    } else {
      this.ShowTodayWorn = false;
    }
  }
  // calculateDistanceDiff() {
  //   //console.log("this.inspectionsHistory 1:", this.inspectionsHistory);
  //   if (this.inspectionsHistory != null) {
  //     var _iCounter = 0;
  //     this.inspectionsHistory.forEach(hx => {
  //       if (_iCounter < this.inspectionsHistory.length) {
  //         var _PrevInspDist = 0;
  //         if (this.inspectionsHistory.length > (_iCounter + 1))
  //           _PrevInspDist = this.inspectionsHistory[_iCounter + 1].DistanceKm;
  //         if (hx.DistanceKm > 0)
  //           hx.DistanceKmDifference = hx.DistanceKm - _PrevInspDist;
  //         _iCounter++;
  //       }
  //       //console.log("this.inspectionsHistory 2:", this.inspectionsHistory);
  //     });
  //   }
  // }
  calculateDistanceDiff() {
    if (this.inspectionsHistory != null && this.inspectionsHistory.length > 0) {
      for (let i = 0; i < this.inspectionsHistory.length; i++) {
        const currentInsp = this.inspectionsHistory[i];
        let prevInspDistance = 0;
        let j = i + 1;
  
        // Find the previous DistanceKm > 0 by iterating backwards
        while (j < this.inspectionsHistory.length) {
          if (this.inspectionsHistory[j].DistanceKm > 0) {
            prevInspDistance = this.inspectionsHistory[j].DistanceKm;
            break;
          }
          j++;
        }
  
        if (currentInsp.DistanceKm > 0) {
          currentInsp.DistanceKmDifference = currentInsp.DistanceKm - prevInspDistance;
        } else {
          currentInsp.DistanceKmDifference = 0; // Default value if current DistanceKm is not valid
        }
      }
    }
  }

  getUserPref(){
    this._pref.getUserPreferences().subscribe(res => {
      this.ShowTodayWorn = res.UCShowWornPerToday == 1 ? true : false;
      this.userUOD = res.UnitofDistance;
    });
  }

//TT-9235
   // to convert distance from kilometers to miles for display purpose
 convertDistanceKmToMi(distance: number): number {
  return this.userUOD === 'km' ? distance : Math.round(distance * 0.621371 * 10) / 10;
  }

  GetEvalColour(compType, worn: number) {
    if (this.EvalautionRange == null)
      return 'Eval-U';
    
    switch (compType) {
      case 230: //Link
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 231://Bush
        if (this.EvalautionRange.BushC != null) {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.BushC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.BushA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.BushB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 232: //Shoe
        if (this.EvalautionRange.ShoeC != null) {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ShoeC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ShoeA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ShoeB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 233://Idler
        if (this.EvalautionRange.LinkC != null && this.EvalautionRange.LinkC != undefined) {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.LinkC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.LinkA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.LinkB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 234://carrier Roller
        if (this.EvalautionRange.CarrierRollerC != null) {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CarrierRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CarrierRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CarrierRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 235://track Roller
        if (this.EvalautionRange.TrackRollerC != null) {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.TrackRollerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.TrackRollerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.TrackRollerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 236://Sprokcket
        if (this.EvalautionRange.SprocketC != null) {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.SprocketC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.SprocketA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.SprocketB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 240://Elognation
        if (this.EvalautionRange.ElongationC != null) {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.ElongationC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.ElongationA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.ElongationB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 417://Crawler
        if (this.EvalautionRange.CrawlerGuideC != null) {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.CrawlerGuideC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.CrawlerGuideA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.CrawlerGuideB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }

      case 446://RSREAR
        if (this.EvalautionRange.RSRearIdlerC != null) {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else if (worn <= this.EvalautionRange.RSRearIdlerC)
            return 'Eval-C';
          else
            return 'Eval-X';
        } else {
          if (worn <= this.EvalautionRange.RSRearIdlerA)
            return 'Eval-A';
          else if (worn <= this.EvalautionRange.RSRearIdlerB)
            return 'Eval-B';
          else
            return 'Eval-X';
        }
      case 237://Idler

        if (worn <= 30)
          return 'Eval-A';
        else if (worn <= 50)
          return 'Eval-B';
        else if (worn <= 70)
          return 'Eval-C';
        else
          return 'Eval-X';


      default:
        break;
    }
  }

  EvalautionRange: CustomeEvaluationRangeVM;
    LoadEvalautionForEquipment(equipmentid: number) {
      this._evalService.GetSelectedLevelRangesForSelectedEquipment(equipmentid).subscribe(res => {
        this.EvalautionRange = res;
      })
    }

    truncateToOneDecimal(value: number): number {
  return Math.floor(value * 10) / 10;
}
}

